import { defineManifest } from "@myndland/game-core";

export const manifest = defineManifest({
  id: "waterway",
  name: "Waterway",
  version: "0.1.0",
  description:
    "Turn carved stones to lead spring water to every flower bed. A calm focus signal shapes light, sound and water speed but never solves the puzzle. Five courses, each targeting a different attention skill.",
  signals: ["focus"],
  tags: ["puzzle", "neurofeedback", "attention"],
  // `module` is the v1 validation service's module; `program` and each level's `moduleName` are the training
  // upload API's validation_program and module_name (external.yaml v2), used for session ZIP uploads.
  // The API spells L2 "Tidewall"; the level keeps its in-game title.
  validation: { module: "waterway", program: "waterway" },
  levels: [
    {
      id: "l1",
      title: "Stonebrook",
      subtitle: "L1 · sustained attention",
      description:
        "The base course. Rotate pipe stones so water reaches every bed; difficulty adapts to how you solve. Focus warms the world toward dawn and grows a session garden.",
      file: "l1.html",
      validation: { gameLevel: 1, type: "attention", moduleName: "Stonebrook" },
      tags: ["sustained-attention"],
    },
    {
      id: "l2",
      title: "Tidewell",
      subtitle: "L2 · selective attention",
      description: "An undersea course with distractors to ignore while routing water.",
      file: "l2.html",
      validation: { gameLevel: 2, type: "attention", moduleName: "Tidewall" },
      tags: ["selective-attention"],
    },
    {
      id: "l3",
      title: "Fernwood",
      subtitle: "L3 · attentional switching",
      description: "The routing rule flips mid-puzzle; a puzzle is solved after adapting to several switches in a row.",
      file: "l3.html",
      validation: { gameLevel: 3, type: "attention", moduleName: "Fernwood" },
      tags: ["attentional-switching"],
    },
    {
      id: "l4",
      title: "Skyways",
      subtitle: "L4 · divided attention (shared valve)",
      description: "Two flows share one valve; keep both reservoirs filled at once.",
      file: "l4.html",
      validation: { gameLevel: 4, type: "attention", moduleName: "Skyways" },
      tags: ["divided-attention"],
    },
    {
      id: "l5",
      title: "Spaceways",
      subtitle: "L5 · working memory under load",
      description:
        "Memorise a planet order, then route water to each planet in sequence under the only time limit in the course. Recall slips are tracked as a signal, not a fail state.",
      file: "l5.html",
      validation: { gameLevel: 5, type: "memory", moduleName: "Spaceways" },
      tags: ["working-memory"],
    },
  ],
});

export default manifest;
